import React from 'react';
import { createRoot } from 'react-dom/client';
import 'broadcastchannel-polyfill';
import { store, history } from './json-view-store';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { Route, Switch } from 'react-router-dom';
import JsonViewApp from './json-view-component';
import { authenticationChannelReceiverFactory } from '../../core/middleware/authentication-channel-middleware';
import { buildSubscriptions as buildChannelSubscriptions } from '../pop-up/case-channel-subscriptions';
// eslint-disable-next-line
import { authenticationChannel } from '@codametrix/ui-common';

const currentURL = new URL(`${window?.top?.location}`);
const subscriptions = buildChannelSubscriptions(currentURL);

authenticationChannelReceiverFactory(subscriptions, store);

const App = () => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/" component={JsonViewApp} />
        </Switch>
      </ConnectedRouter>
    </Provider>
  );
};

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(<App />);
